<div class="one-app-list">
  <div class="header">
    <div class="avatar">
      <one-avatar [username]="userInfo.username || userInfo.preferred_username"></one-avatar>
    </div>
    <div class="user-info">
      <div class="fullname">
        {{getFriendlyName()}}
      </div>
      <div class="title">
        {{userInfo.avp_title}}
      </div>
    </div>
  </div>
  <div class="content">
    <div class="app-items">

      <div class="app-item" (click)="goToWeWork()">
        <div class="app-icon app-icon-wework">

        </div>
        <div class="app-name">
          AVP Task
        </div>
        <div class="app-description">
          Task Manager
        </div>
      </div>

      <div class="app-item" (click)="goToMessage()">
        <div class="app-icon app-icon-message">

        </div>
        <div class="app-name">
          AVP Message
        </div>
        <div class="app-description">
          Team Message
        </div>
      </div>
    </div>
  </div>
</div>
